import React, { useEffect, useState } from "react";
import qs from "qs";
import "./styles.less";
// import { useTranslation } from "react-i18next";
import { CommonBlogRqcode } from "../common-blog-rqcode";
import { CommonBlogAuthor } from "../common-blog-author";
import { blogAxios } from "../../utils/blogAxios";
import { Link, useParams } from "react-router-dom";
import { CommonBlogForm, CommonBlogRegister } from "../common-blog-register";

export const BlogDetailAside = ({ articleDetail }) => {
  //   const { t } = useTranslation();
  const [articleList, setArticleList] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    blogAxios
      .get(
        `/articles?${qs.stringify({
          _limit: 5,
          _start: 0,
          _sort: "publishedAt:DESC,published_at:DESC",
          _where: {
            id_nin: [id],
          },
        })}`
      )
      .then(({ data }) => {
        setArticleList(data);
      });
  }, [id]);
  return (
    <section
      style={{
        marginBottom: 20,
        marginLeft: 62,
        width: 340,
        minWidth: 340,
      }}
    >
      <div className="blog-detail-aside">
        <CommonBlogAuthor author={articleDetail?.author} />
        {/* <CommonBlogForm /> */}
        {Boolean(articleList?.length) && (
          <div className="catalog">
            <div className="title">其他文章</div>
            {articleList.map((item, index) => {
              return (
                <Link
                  title={item.title}
                  to={`/blog/${item.id}`}
                  key={index}
                  className="article-item"
                >
                  {index + 1}. {item.title}
                </Link>
              );
            })}
          </div>
        )}

        {/* <CommonBlogRegister /> */}
        <CommonBlogRqcode />
      </div>
    </section>
  );
};
